import React from "react";
import { toast } from "react-toastify";
import useThemeColors from "./ThemeColors";

interface IPROPS {
  closeModal: any;
  setTableData: any;
  fieldsData: any;
  storedData: any;
  refetchingData: any;
  trigger: any;
}
const DeleteModal: React.FC<IPROPS> = ({
  closeModal,
  setTableData,
  fieldsData,
  storedData,
  refetchingData,
  trigger,
}) => {
  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const deleteFieldHandler = async () => {
    const id = storedData.id;
    if (id) {
      try {
        setTableData(fieldsData?.filter((item: any) => item?.id !== id));
        const response = await trigger({ id });
        if (response?.error) {
          toast.error("Unable to delete");
        } else {
          toast.success("Data deleted successfully");
          closeModal(true);
          refetchingData();
        }
      } catch (error) {
        toast.error("An error occurred while deleting the data");
      }
    } else {
      toast.error("Invalid ID, cannot delete data");
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
        fontFamily: "karbon-medium",
      }}
    >
      {/* <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <i
          style={{
            fontSize: "26px",
            color: "black",
            cursor: "pointer",
          }}
          className="bi bi-x"
          onClick={() => closeModal(true)}
        ></i>
      </div> */}
      <div style={{ color: "#3071e4", fontSize: "18px" }}>Are you sure?</div>
      <div style={{ marginBottom: "15px", fontSize: "16px" }}>
        Do you really want to delete these records? This process cannot be
        undone.
      </div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <button
          style={{
            color: `${selectedButtonColors}`,
            background: `${selectedButtonBackgoundColors}`,
            border: "none",
            padding: "10px 15px",
            borderRadius: "20px",
          }}
          onClick={deleteFieldHandler}
        >
          Delete
        </button>
        <button className="btn btn-light" onClick={() => closeModal(true)}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteModal;
